// extracted by mini-css-extract-plugin
export var SectionHeader = "index-module--SectionHeader--brTrd";
export var desc = "index-module--desc--Ymgro";
export var descInfo = "index-module--descInfo--ShZ5p";
export var section_header = "index-module--section_header--uSx-F";
export var section_header_mb = "index-module--section_header_mb--RLkyb";
export var textBg = "index-module--textBg--wZEgG";
export var title = "index-module--title--mN+Th";